// Provenance: repo:tds-reconciliation-portal:frontend/src/components/TieOutBanner.tsx
// (ADR-0005) — restyled on the estate tokens (ADR-0010).
import type { ControlTotals } from '../api/types'
import { Money } from './Money'

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex flex-col items-end">
      <span className="text-xs uppercase text-muted-foreground">{label}</span>
      <Money v={value} bold className="text-lg" />
    </div>
  )
}

/** Headline tie-out banner: the gate result, straight from control_totals. */
export function TieOutBanner({ ct }: { ct: ControlTotals }) {
  const ok = ct.ties_ok
  return (
    <div
      className={`rounded-md border p-4 ${
        ok
          ? 'border-emerald-300 bg-emerald-50'
          : 'border-red-300 bg-red-50'
      }`}
    >
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <span
            className={`flex h-11 w-11 items-center justify-center rounded-full text-xl text-white ${
              ok ? 'bg-emerald-600' : 'bg-red-600'
            }`}
          >
            {ok ? '✓' : '✗'}
          </span>
          <div>
            <p className={`text-2xl font-extrabold leading-tight ${
              ok ? 'text-emerald-900' : 'text-red-900'
            }`}>
              {ok ? 'TIES OK' : 'TIE-OUT FAILED'}
            </p>
            <p className="text-sm text-muted-foreground">
              {ok
                ? 'Categories foot to the gap and the ledger rolls forward.'
                : 'Control totals do not reconcile — results are unreliable.'}
            </p>
          </div>
        </div>
        <div className="flex gap-6">
          <Stat label="26AS TDS" value={ct.tds_26as} />
          <Stat label="Ledger Dr" value={ct.ledger_dr} />
          <Stat label="Gap" value={ct.gap} />
        </div>
      </div>
    </div>
  )
}
